export default __webpack_public_path__ + "static/media/bar_chart-gray.3bbc5b1c.svg";